import React from 'react'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import { Dialog } from 'primereact/dialog'
import { LuxButton } from '@lux/wardrobe-lib'
import './DialogDownloadList.scss'
import { NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE } from '@/app/redux/reducers/activity-creation'

const DialogDownloadList = (props: {
    dialogVisible: boolean
    onSave: () => void
    onHide: () => void
}) => {
    const { dialogVisible, onSave, onHide } = props

    const intl = useIntl()

    const componentClass = 'smart-modals-dialog-download-list'

    const renderFooter = () => {
        return (
            <div className={`${componentClass}__buttons`}>
                <LuxButton
                    onClick={onHide}
                    variant="outlined"
                    text={intl.formatMessage({
                        id: 'modals.dialog.buttons.cancel',
                        defaultMessage: 'Cancel',
                    })}
                />
                <LuxButton
                    onClick={onSave}
                    text={intl.formatMessage({
                        id: 'modals.dialog.buttons.proceed',
                        defaultMessage: 'Proceed',
                    })}
                />
            </div>
        )
    }

    return (
        <Dialog
            header={intl.formatMessage({
                id: 'modals.new.activity.section.distribution.store_list.download',
                defaultMessage: 'Download Store list',
            })}
            draggable={false}
            visible={dialogVisible}
            onHide={() => onHide()}
            footer={renderFooter()}
            style={{ width: '50vw' }}
            maskClassName={componentClass}
            breakpoints={{ '960px': '85vw' }}>
            <div className={`${componentClass}__content`}>
                {intl.formatMessage({
                    id: 'modals.new.activity.section.distribution.store_list.download_message',
                    defaultMessage: 'Are you sure you want to download the store list?',
                })}
            </div>
        </Dialog>
    )
}

const mapStateToProps = (state: any) => ({
    changelog: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].changelog,
})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(DialogDownloadList)
